<template>
  <transition name="fade">
    <div class="comment-list-container" v-if="commentListState">
      <div class="comment-list-mask" @touchmove.prevent />
      <div class="comment-list-content" @click.stop="handleClose">
        <cube-scroll ref="commentScroll" :data="viewCommentData.comments" :options="options" @pulling-up="onPullingUp">
          <template v-for="(item, index) in viewCommentData.comments">
            <div class="comment-list-item flex" :key="index" @click.stop>
              <img class="author-avatar" :src="item.user ? item.user.avatar : ''" alt="">
              <div class="comment-info flex-column">
                <span class="comment-author" v-if="item.user">{{ item.user.username }}</span>
                <p class="comment">{{ item.comment }}</p>
                <div class="flex-between comment-operation">
                  <span class="comment-time">{{ item.created_at | timeFormat }}</span>
                  <div class="icon-container flex-end" v-if="item.allow_delete" @click="deleteCommentItem(item)">
                    <i class="iconfont icontrash-"></i>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </cube-scroll>
      </div>
      <div class="comment-input flex-start" :class="{'comment-input-android-browser': isAndroidBrowser}" v-show="!isCommentState">
        <div class="comment-close flex-center" @click="handleClose">
          <i class="iconfont iconx" />
        </div>
<!--        <button @click="handleCommentScroll">调试滚动，请忽略</button>-->
        <button class="comment-input-value flex-start" @click="changeCommentDialogState">
          <i class="iconfont iconbianji"></i>
          <span>发表我的看法...</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import WAutoTextarea from '../../../../components/global/w-auto-textarea'
  import {envMixin} from "../../../../assets/js/mixin/global";
  import {componentsMixin} from "../../../../assets/js/mixin/components";
  export default {
    name: 'commentList',
    mixins: [envMixin, componentsMixin],
    props: {
      commentListState: {
        type: Boolean,
        default: false
      },
      isCommentState: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        commentText: '',
        scrollEvents: [ 'scroll' ],
        options: {
          pullUpLoad: true
        }
      }
    },
    mounted() {},
    computed: {
      ...mapGetters('cvShare', [ 'viewCommentData' ]),
      loadingMore () {
        let { comments, comment_count } = this.viewCommentData
        return comments.length < comment_count
      }
    },
    watch: {
      commentListState(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.commentScroll.scrollTo(0, 0)
            setTimeout(() => {
              this.$refs.commentScroll.refresh()
            }, 300)
          })
        }
      }
    },
    components: {
      WAutoTextarea
    },
    methods: {
      ...mapActions('cvShare', [ 'deleteCommentForCv', 'getCommentData' ]),
      // 上拉加载更多
      onPullingUp() {
        if (this.loadingMore) {
          let { comments, comment_count, info_id, type } = this.viewCommentData
          let payload = {
            page: Math.floor(comments.length / 10) + 1,
            size: 10,
            info_id,
            type
          }
          this.getCommentData({ payload })
        }
      },
      // 删除点评
      deleteCommentItem(item) {
        this.$createDialog({
          title: '提示',
          type: 'confirm',
          content: `删除后将不可恢复，确认删除此条点评吗？`,
          onConfirm: async () => {
            try {
              let res = await this.deleteCommentForCv({ commentId: item.id })
              if (res.code === 1000) {
                this.showToast('删除成功', 1500)
                if (res.commentEmpty) this.handleClose()
              } else {
                this.showToast('删除失败，请重试', 1500)
              }
            } catch (e) {
              this.showToast('删除失败，请重试', 1500)
              console.log(e)
            }
          }
        }).show()
      },
      // dispatch 关闭事件
      handleClose() {
        this.$emit('handleClose')
      },
      // 点击弹窗评论事件
      changeCommentDialogState() {
        this.$emit('changeCommentDialogState')
      },
      handleCommentScroll() {
        if (this.$refs.commentScroll) {
          let scrollContent = document.querySelector('.cube-scroll-content')
          this.$refs.commentScroll.scrollTo(0, -scrollContent.clientHeight + window.innerHeight + 5)
        }
      }
    },
    filters: {
      timeFormat(val) {
        let moment = require('moment')
        let diff = moment().diff(moment(val), 'years')
        if (diff < 1) {
          return moment(val).format('MM-DD HH:mm')
        } else {
          return moment(val).format('YYYY-MM-DD')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/global/variable";
  @import "../../../../assets/scss/global/mixin";
  .comment-list-container {
    width: 100vw;
    height: $screen-height;
    position: fixed;
    z-index: 313;
    top: 0;
    .comment-list-mask {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 312;
      background-color: rgba($color: #000, $alpha: .5);
    }
    .comment-list-content {
      width: 100vw;
      height: $screen-height;
      position: fixed;
      z-index: 316;
      padding: 0 16px;
      top: 0;
      @include ipx-content-bottom(1px);
      .comment-list-item {
        margin-bottom: 26px;
        &:first-child {
          margin-top: 82px;
        }
        &:last-child {
          margin-bottom: 114px;
          /*margin-bottom: ipxConstantHeight(110px) !important;*/
          /*margin-bottom: ipxEnvHeight(110px) !important;*/
        }
        .author-avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          object-fit: contain;
          margin-right: 10px;
          background-color: $color-light;
        }
        .comment-info {
          background-color: #333333;
          color: $color-light;
          flex: 1;
          padding: 16px 20px 12px;
          border-radius: 6px;
          // @include bubble-style-2(auto, auto, #333333, 1);
          .comment-author {
            line-height: 20px;
            margin-bottom: 2px;
          }
          .comment {
            line-height: 24px;
            font-size: $font-size-medium-x;
            padding-bottom: 12px;
            border-bottom: 1px solid $color-title;
            word-break: break-all;
          }
          .comment-operation {
            line-height: 20px;
            height: 20px;
            padding-top: 12px;
            .comment-time {
              font-size: $font-size-small;
              color: #9c9c9c;
            }
            .icon-container {
              width: 20px;
              height: 20px;
              i {
                color: #9c9c9c;
              }
            }
          }
        }
      }
    }
    .comment-input {
      position: fixed;
      @include fixed-bottom(42px);
      z-index: 318;
      padding: 0 18px;
      background-color: transparent;
      width: 100vw;
      .comment-close {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        background-color: $color-title;
        color: $color-light;
        margin-right: 16px;
        i {
          font-weight: bold;
          font-size: 24px;
        }
      }
      .comment-input-value {
        flex: 1;
        border-radius: 24px;
        background-color: $color-title;
        padding: 12px 20px;
        color: $color-light;
        font-size: $font-size-medium-x;
        border: none;
        text-align: left;
        i {
          margin-right: 8px;
        }
      }
      .textarea-content {
        padding: 0 20px 0 10px;
        border-radius: 24px;
        background-color: $color-title;
        flex: 1;
        .auto-textarea {
          width: 100%;
          line-height: 21px;
          font-size: $font-size-medium-x;
          background-color: $color-title;
          outline: none;
          padding: 12px 0 12px 10px;
          color: $color-light;
          border: none;
          resize: none;
        }
      }
    }
    .comment-input-android-browser {
      bottom: 42px;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>